import React, { useEffect } from 'react';
import useValidationCode, { formatTime } from '../../components/useValidationCode';
import { alphabets, nombres } from '../../components/enigmes/e_alphab.js';
import '../../css/Fin.css';

function Fin() {
    const {
        inputValue, showVideo, errorMessage, attemptHistory,
        isBlocked, remainingTime, pending,
        addLetter: handleClick, reset: handleReset, validate: handleValidation,
    } = useValidationCode(1);

    useEffect(() => {
        document.title = 'Fin';
    }, []);

    const placeholderText = isBlocked
        ? `Vous êtes bloqué pendant encore ${formatTime(remainingTime)}`
        : 'Cliquez sur les lettres pour les ajouter';

    return (
        <div className='fin'>
            <div className="espaceHaut"></div>
            <div className="alphabet-container" style={{ display: 'flex', flexWrap: 'wrap', padding: 0, justifyContent: 'center' }}>
                {Object.entries(alphabets).map(([letter, image]) => (
                    <img
                        key={letter}
                        src={`${process.env.PUBLIC_URL}/img/alphab/${image}`}
                        alt={letter}
                        onClick={() => handleClick(letter)}
                        style={{ cursor: 'pointer', margin: 0, padding: 0, height: '80px' }}
                    />
                ))}

                {Object.entries(nombres).reduce((rows, [number, image], index) => {
                    const rowIndex = Math.floor(index / 10);
                    if (!rows[rowIndex]) {
                        rows[rowIndex] = []; // Initialise une nouvelle ligne si nécessaire
                    }
                    rows[rowIndex].push(
                        <img
                            key={number}
                            src={`${process.env.PUBLIC_URL}/img/alphab/${image}`}
                            alt={number}
                            onClick={() => handleClick(number)}
                            style={{
                                cursor: 'pointer',
                                margin: '2px',
                                padding: 0,
                                height: '80px',
                            }}
                        />
                    );
                    return rows;
                }, []).map((row, rowIndex) => (
                    <div
                        key={rowIndex}
                        style={{ display: 'flex', flexDirection: 'row', marginBottom: '10px', padding: 0, justifyContent: 'center' }}
                    >
                        {row}
                    </div>
                ))}
            </div>

            {errorMessage && <p style={{ color: isBlocked ? 'red' : 'white' }}>{errorMessage}</p>}

            <ul>
                {attemptHistory.map((attempt, index) => (
                    <li key={index} style={{ color: 'gray' }}>
                        {attempt}
                    </li>
                ))}
            </ul>

            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', flexWrap: 'wrap', justifyContent: 'center' }}>
                <input
                    type="text"
                    value={inputValue}
                    readOnly
                    placeholder={placeholderText}
                    style={{ marginTop: '10px', padding: '5px', width: '400px' }}
                />
                <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                    <button
                        onClick={handleValidation}
                        style={{ margin: '10px 0px 15px 10px', padding: '5px 15px' }}
                        disabled={isBlocked || pending || !inputValue}
                        className="btn btnBeige"
                    >
                        validation
                    </button>
                    <button
                        onClick={handleReset}
                        style={{ marginTop: '10px', padding: '5px 15px' }}
                        disabled={isBlocked}
                        className="btn"
                    >
                        reset
                    </button>
                </div>
            </div>

            {showVideo && (
                <div>
                    <p>Voici la vidéo :</p>
                    <video width="600" controls>
                        <source src="https://www.astolie.fr/img/1409579861.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            )}
        </div>
    );
}

export default Fin;
